import React from 'react';
import { View, Text, StyleSheet, ScrollView, ImageBackground, Platform, useWindowDimensions } from 'react-native';
import { colores, fuentes } from '../../styles/variablesCss';

const Historia = () => {
  const { width } = useWindowDimensions();
  const isSmall = width < 576;
  const isMedium = width >= 576 && width < 992;

  const heroHeight = isSmall ? 280 : isMedium ? 420 : 580;
  const lineFont = isSmall ? 36 : isMedium ? 56 : 75;
  const lineHeight = lineFont;
  const textBlockBottom = isSmall ? 24 : 40;
  const textBlockMarginLeft = isSmall ? '6%' : '12%';
  const breadcrumbFont = isSmall ? 11 : 12;
  const contentPaddingV = isSmall ? 16 : 20;
  const sideTitleSize = isSmall ? 20 : 24;
  const bodyFont = isSmall ? 14 : 16;
  const bodyLineHeight = isSmall ? 20 : 20;
  const columnsDirection = isSmall ? 'column' : 'row';
  const leftFlex = isSmall ? undefined : 2;
  const rightFlex = isSmall ? undefined : 1;
  const bottomBannerHeight = isSmall ? 160 : 200;
  const bottomQuoteFont = isSmall ? 14 : 22;

  return (
    <ScrollView contentContainerStyle={styles.page}>
      <View style={styles.hero}>
        <ImageBackground
          source={{ uri: 'https://www.pinguino.com.ar/static/img/historia1.png' }}
          style={[styles.heroImage, { height: heroHeight }]}
          imageStyle={styles.heroImageInner}
          resizeMode="cover"
        >
          <View style={styles.overlay} />
          {/* Breadcrumb superior */}
          <View style={styles.breadcrumb}>
            <Text style={[styles.breadcrumbText, { fontSize: breadcrumbFont }]}>Pingüino |
              <Text style={styles.breadcrumbBold}> Historia</Text>
            </Text>
          </View>
          <View style={[styles.textBlock, { bottom: textBlockBottom, marginLeft: textBlockMarginLeft }] }>
            <Text style={[styles.line, styles.white, { fontSize: lineFont, lineHeight } ]}>NUESTRO</Text>
            <Text style={[styles.line, styles.white, { fontSize: lineFont, lineHeight } ]}>IMPULSO</Text>
            <Text style={[styles.line, styles.red, { fontSize: lineFont, lineHeight } ]}>PARA SEGUIR</Text>
            <Text style={[styles.line, styles.red, { fontSize: lineFont, lineHeight } ]}>CRECIENDO</Text>
          </View>
        </ImageBackground>
      </View>

      {/* Bloque de contenido inferior */}
      <View style={[styles.contentWrap, { paddingVertical: contentPaddingV }]}>
        <View style={[styles.columns, { flexDirection: columnsDirection }]}>
          {/* Columna izquierda - historia completa */}
          <View style={[styles.leftCol, leftFlex ? { flex: leftFlex } : { width: '100%' }]}>
            <Text style={[styles.introStrong, { fontSize: bodyFont, lineHeight: bodyLineHeight }]}>
              Somos una empresa familiar nacida en 1975 como mayorista de productos de consumo masivo y en 1977, acompañando el proceso de concentración del mercado minorista, abrimos nuestra primera boca de autoservicio en la localidad de Rafaela (Santa Fe).
            </Text>

            <Text style={[styles.paragraph, { fontSize: bodyFont, lineHeight: bodyLineHeight }]}>
              Desde hace más de 45 años crecemos sostenidamente en nuestros dos canales de comercialización, apoyados en sólidos valores reconocidos por nuestros clientes.
            </Text>

            <Text style={[styles.paragraph, { fontSize: bodyFont, lineHeight: bodyLineHeight }]}>
              En la esfera mayorista, logramos una cobertura regional en 4 provincias y, en el minorista, 8300 mts2 repartidos en 8 sucursales; 7 establecidas en Rafaela y 1 en San Francisco (Córdoba). También contamos con un Centro de Producción de panificados y pastas frescas, con productos caseros respaldados diariamente por quienes nos eligen, y un Centro de Distribución de productos secos y frescos. Además, tenemos dos marcas propias que ofrecen calidad y seguridad alimentaria a nuestros clientes: Estancia Los Sauces, de cortes de carnes premium, y Coral Sea, de alimentos enlatados.
            </Text>

            <Text style={[styles.paragraph, { fontSize: bodyFont, lineHeight: bodyLineHeight }]}>
              Desde 2010 elaboramos reportes de Responsabilidad Social Empresaria en el marco del Pacto Global de las Naciones Unidas, dando muestra de nuestro compromiso con la comunidad y el entorno en donde nos desarrollamos como institución.
            </Text>
          </View>

          {/* Columna derecha - Vision, Mision, Valores */}
          <View style={[styles.rightCol, rightFlex ? { flex: rightFlex } : { width: '100%', marginTop: 16 }]}>
            <Text style={[styles.sideTitle, { fontSize: sideTitleSize }]}>VISIÓN:</Text>
            <Text style={[styles.sideText, { fontSize: bodyFont, lineHeight: bodyLineHeight }]}>
              Ser una empresa reconocida en la región por su excelencia en servicio y máxima eficiencia, con un desempeño responsable en materia social y ambiental.
            </Text>

            <Text style={[styles.sideTitle, { marginTop: 12, fontSize: sideTitleSize }]}>MISIÓN:</Text>
            <Text style={[styles.sideText, { fontSize: bodyFont, lineHeight: bodyLineHeight }]}>
              Somos una empresa de comercialización mayorista y minorista de productos masivos que agrega valor con eficiencia y calidad de servicio, mejorando la calidad de vida de la sociedad que nos nutre.
            </Text>

            <Text style={[styles.sideTitle, { marginTop: 12, fontSize: sideTitleSize }]}>VALORES:</Text>
            <View style={styles.valuesList}>
              <Text style={[styles.valueItem, { fontSize: bodyFont - 2 } ]}>· Innovación.</Text>
              <Text style={[styles.valueItem, { fontSize: bodyFont - 2 } ]}>· Calidad.</Text>
              <Text style={[styles.valueItem, { fontSize: bodyFont - 2 } ]}>· Eficiencia.</Text>
              <Text style={[styles.valueItem, { fontSize: bodyFont - 2 } ]}>· Respeto.</Text>
              <Text style={[styles.valueItem, { fontSize: bodyFont - 2 } ]}>· Confianza.</Text>
            </View>
          </View>
        </View>
      </View>

      {/* Texto centrado inferior sobre imagen local */}
      <ImageBackground
        source={require('../../assets/historia3.png')}
        style={[styles.bottomBanner, { height: bottomBannerHeight }]}
        resizeMode="cover"
      >
        <View style={styles.bottomOverlay} />
        <View style={styles.bottomQuoteWrap}>
          <Text style={[styles.bottomQuoteLine, { fontSize: bottomQuoteFont }]}>Desde hace más de 45 años crecemos sostenidamente</Text>
          <Text style={[styles.bottomQuoteLine, { fontSize: bottomQuoteFont }]}>en nuestros dos canales de comercialización, apoyados</Text>
          <Text style={[styles.bottomQuoteLine, { fontSize: bottomQuoteFont }]}>en sólidos valores reconocidos por nuestros clientes.</Text>
        </View>
      </ImageBackground>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 0,
  },
  hero: {
    width: '100%',
    alignSelf: 'center',
  },
  heroImage: {
    width: '100%',
    height: 580,
    position: 'relative',
  },
  heroImageInner: {
    // sin bordes, full-bleed
  },
  overlay: {
    ...Platform.select({
      web: { backgroundColor: 'rgba(0,0,0,0.0)' },
      default: { backgroundColor: 'transparent' },
    }),

    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  textBlock: {
    marginLeft: '12%',
    position: 'absolute',
    left: 24,
    bottom: 40,
  },
  line: {
    fontFamily: fuentes.bold,
    fontSize: 75,
    lineHeight: 75,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    marginBottom: 6,
    ...Platform.select({
      web: { textShadow: '0 2px 6px rgba(0,0,0,0.25)' },
      default: {},
    }),
  },
  white: {
    color: '#ffffff',
  },
  red: {
    color: colores.rojo,
  },
  // Highlight band
  highlightWrap: {
    width: '100%',
    backgroundColor: colores.blanco,
  },
  highlightBg: {
    width: '100%',
    height: 200,
    position: 'relative',
  },
  highlightOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(198,40,40,0.6)', // rojo translúcido
  },
  highlightInner: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
  },
  highlightText: {
    color: '#fff',
    fontFamily: fuentes.semiBold,
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 22,
  },
  waveSeparator: {
    height: 12,
    backgroundColor: colores.blanco,
  },
  contentWrap: {
    backgroundColor: colores.blanco,
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  columns: {
    maxWidth: 1100,
    alignSelf: 'center',
    flexDirection: 'row',
    gap: 24,
    ...Platform.select({
      web: {},
      default: { flexDirection: 'column' },
    }),
  },
  bottomQuoteLine: {
    fontFamily: fuentes.bold,
    fontSize: 22,
    color: colores.blanco,
    
  },
  leftCol: {
    flex: 2,
  },
  rightCol: {
    flex: 1,
  },
  introStrong: {
    fontFamily: fuentes.bold,
    fontSize: 16,
    color: colores.texto,
    lineHeight: 20,
    marginBottom: 10,
  },
  paragraph: {
    fontSize: 16,
    color: colores.texto,
    lineHeight: 20,
    marginBottom: 10,
  },
  sideTitle: {
    color: colores.rojo,
    fontFamily: fuentes.bold ,
    fontSize: 24,
  },
  sideText: {
    fontSize: 16,
    color: colores.texto,
    lineHeight: 20,
  },
  valuesList: {
    marginTop: 4,
  },
  valueItem: {
    fontSize: 14,
    color: colores.texto,
    lineHeight: 20,
  },
  // Bottom banner with local image and overlay text
  bottomBanner: {
    width: '100%',
    height: 200,
    position: 'relative',
    marginTop: 10,
  },
  bottomOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.25)'
  },
  bottomQuoteWrap: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
  },
  bottomQuote: {
    color: '#fff',
    fontFamily: fuentes.semiBold,
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 22,
  },
  // Breadcrumb over hero
  breadcrumb: {
    marginLeft: '12%',
    position: 'absolute',
    top: 8,
    left: 12,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  breadcrumbText: {
    color: '#fff',
    fontSize: 12,
    letterSpacing: 0.2,
  },
  breadcrumbBold: {
    fontFamily: fuentes.bold,
  },
});

export default Historia;
